export default "__VITE_ASSET__BMjlYCHC__"